import { useMemo } from 'react'
import { useKpiDimStackable } from '~/api/hooks/useCatalog'
import {
  resolveSeriesAdditivity,
  type AdditivityVerdict,
} from '~/components/Charts/seriesAdditivity'
import type { Facet } from '~/state/useChartKnobsState'

/** Per-kpi additivity resolver for surfaces that evaluate SEVERAL kpis against one
 *  group-by (Dynamics primary + compare metrics). Same precedence as
 *  resolveSeriesAdditivity — this is a keying convenience, not a second rule. */
export function useAdditivityForGroupBy(
  factTable: string,
  groupBy: string[],
): (kpi: string, effectiveValueTypes: string[]) => AdditivityVerdict {
  const stack = useKpiDimStackable(factTable)
  return useMemo(
    () => (kpi: string, effectiveValueTypes: string[]) =>
      resolveSeriesAdditivity({
        groupBy,
        effectiveValueTypes,
        stackableRows: stack.data,
        kpi,
      }),
    [groupBy, stack.data],
  )
}

/** stacked_area survives only when the selection is additive; otherwise fall back to line. */
export function stackedAreaFacet(
  defaultFacet: string | null | undefined,
  stackable: boolean,
): Facet {
  return defaultFacet === 'stacked_area' && stackable ? 'stacked_area' : 'line'
}
